import { render, staticRenderFns } from "./TrainTask.vue?vue&type=template&id=fb06e568&scoped=true"
import script from "./TrainTask.vue?vue&type=script&lang=js"
export * from "./TrainTask.vue?vue&type=script&lang=js"
import style0 from "./TrainTask.vue?vue&type=style&index=0&id=fb06e568&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb06e568",
  null
  
)

export default component.exports